<ngx-simplebar [options]="{ autoHide: false }" class="widget expectedEnergyLoss">
  <app-expected-energy-loss
    [energyLoss]="energyToolFacade.energyLoss()"
    [expectedEnergyLossPerDay]="energyToolFacade.expectedEnergyLossPerDay()"
    [energyCost]="energyToolFacade.energyCost()"
    (changeTimeframeEvent)="onChangeTimeExpecteEnergyLoss($event)"
  >
  </app-expected-energy-loss>
</ngx-simplebar>

<ngx-simplebar [options]="{ autoHide: false }" class="widget doughnutChart">
  <app-doughnut-chart
    [chartData]="energyToolFacade.doughnutChartEnergyLoss()"
    [sourceType]="sourceType"
    (changeTimeframeEvent)="onChangeTimeDoughnutChart($event)"
    chartId="locationDoughnutChart"
  >
  </app-doughnut-chart>
</ngx-simplebar>

<ngx-simplebar [options]="{ autoHide: false }" class="widget weatherReport">
  <app-weather-report
    [sourceType]="sourceType"
    [forecastEnergyLossData]="energyToolFacade.forecastEnergyLoss()"
    [forecastWeatherData]="energyToolFacade.forecastWeather()"
  ></app-weather-report>
</ngx-simplebar>

<ngx-simplebar [options]="{ autoHide: false }" class="widget barChart">
  <app-bar-chart
    [chartData]="energyToolFacade.barChartEnergyLoss()"
    (changeTimeframeEvent)="onChangeTimeBarChart($event)"
    [sourceType]="sourceType"
    [sourceId]="sourceId"
    chartId="locationBarChart"
  >
  </app-bar-chart>
</ngx-simplebar>

<ngx-simplebar [options]="{ autoHide: false }" class="widget lineChart">
  <app-line-chart
    [chartData]="energyToolFacade.lineChartEnergyLoss()"
    (changeTimeframeEvent)="onChangeTimeLineChart($event)"
    [sourceType]="sourceType"
    [sourceId]="sourceId"
    chartId="locationLineChart"
  >
  </app-line-chart>
</ngx-simplebar>
